import React from "react";
import { Link } from "react-router-dom";

export default function PaymentSuccess({ handelModalType }) {
  return (
    <div className="bg-[#141414] border border-gray-800 p-8 px-6 md:px-16 rounded-2xl md:mx-auto max-w-md w-full shadow-2xl text-center text-white">
      <div className="w-20 h-20 bg-green-500/10 border border-green-500/20 rounded-full flex items-center justify-center mx-auto mb-6">
        <svg
          viewBox="0 0 24 24"
          className="text-green-500 w-10 h-10"
        >
          <path
            fill="currentColor"
            d="M12,0A12,12,0,1,0,24,12,12.014,12.014,0,0,0,12,0Zm6.927,8.2-6.845,9.289a1.011,1.011,0,0,1-1.43.188L5.764,13.769a1,1,0,1,1,1.25-1.562l4.076,3.261,6.227-8.451A1,1,0,1,1,18.927,8.2Z"
          ></path>
        </svg>
      </div>
      <div>
        <h3 className="md:text-2xl text-xl text-white font-bold text-center mb-2">
          Payment Done!
        </h3>
        <p className="text-gray-400 my-2 text-sm md:text-base">
          Thank you for completing your secure online payment.
        </p>
        <p className="text-gray-400 text-sm">Have a great day!</p>
        <div className="mt-8 text-center">
          <Link
            replace={true}
            to="/Detail"
            className="inline-block w-full bg-secondary hover:bg-orange-500 text-white font-semibold py-3 px-8 rounded-xl transition-all hover:scale-[1.02] active:scale-95 shadow-md shadow-secondary/20"
          >
            View Item
          </Link>
        </div>
      </div>
    </div>
  );
}
